
import { ObjectTypes } from '../services/ObjectSolverService.js';

const {
	OEUVRE_TYPE,
	PAINTING_TYPE,
	STATUE_TYPE,
	DRAGHANDLE_COMMENT_TYPE,
	DRAGHANDLE_METER_TYPE,
	DRAGHANDLE_POLYGON_TYPE,
	ADDITIONALOBJECT_TYPE,
	ADDITIONALOBJECT_CUBE_TYPE,
	ADDITIONALOBJECT_JSON_TYPE,
	ADDITIONALOBJECT_LIGHT_TYPE,
	ADDITIONALOBJECT_AMBIENTLIGHT_TYPE,
	ADDITIONALOBJECT_DIRECTIONALLIGHT_TYPE,
	ADDITIONALOBJECT_HEMISPHERELIGHT_TYPE,
	ADDITIONALOBJECT_POINTLIGHT_TYPE,
	ADDITIONALOBJECT_SPOTLIGHT_TYPE,
	ADDITIONALWALL_TYPE
} = ObjectTypes;

export default class ObjectNamingService {

	constructor( $rootScope, gettextCatalog, objectSolverService ) {

		this.gettextCatalog      = gettextCatalog;
		this.objectSolverService = objectSolverService;

		this.objectTypeI18nLabels = {};

		this.objectTypes = ObjectTypes;

		Object.keys( this.objectTypes ).forEach( key => {

			var type  = this.objectTypes[ key ];
			var label = gettextCatalog.getStringIfExists( 'label:' + type );

			if (label) {
				this.objectTypeI18nLabels[ type ] = label;
			}
		});
	
		if (!this.objectTypeI18nLabels[ ADDITIONALOBJECT_TYPE ]) {
			this.objectTypeI18nLabels[ ADDITIONALOBJECT_TYPE ] = gettextCatalog.getString( 'label:additionalObject.' );
		}

		var __objectTypeI18nLabelsForTheGruntGettextExtractor = [
			gettextCatalog.getString( 'label:oeuvre' ),
			gettextCatalog.getString( 'label:oeuvre.painting' ),
			gettextCatalog.getString( 'label:oeuvre.statue' ),
			gettextCatalog.getString( 'label:dragHandle.comment' ),
			gettextCatalog.getString( 'label:dragHandle.meter' ),
			gettextCatalog.getString( 'label:dragHandle.polygon' ),
			gettextCatalog.getString( 'label:additionalWall' )
		];
	}
	
	getName( object, type ) {

		switch (type) {

			// Yleistapaus
			case OEUVRE_TYPE:
			case PAINTING_TYPE:
			case STATUE_TYPE:
			case ADDITIONALOBJECT_TYPE:
			case ADDITIONALOBJECT_CUBE_TYPE:
			case ADDITIONALOBJECT_JSON_TYPE:
			case ADDITIONALOBJECT_LIGHT_TYPE:
			case ADDITIONALOBJECT_AMBIENTLIGHT_TYPE:
			case ADDITIONALOBJECT_DIRECTIONALLIGHT_TYPE:
			case ADDITIONALOBJECT_HEMISPHERELIGHT_TYPE:
			case ADDITIONALOBJECT_POINTLIGHT_TYPE:
			case ADDITIONALOBJECT_SPOTLIGHT_TYPE:
			case ADDITIONALWALL_TYPE:
				return object.title;

			// Fallback
			default:
				return;
		}
	}

	getIdentification( object, type ) {
		
		var uuid;

		switch (type) {

			case OEUVRE_TYPE:
			case PAINTING_TYPE:
			case STATUE_TYPE:
				return object.uid;

			// Fallback
			default:
				uuid = object.uuid;
		}

		if (uuid) {
			return uuid.substr( 0, 4 );

			// return uuid; Skipataan lukukelvoton uuid, koska se on lukukelvoton
		}
	}
		
	solveName( object ) {

		var { gettextCatalog, objectSolverService } = this;
		
		var type   = objectSolverService.solveObjectType( object );
		var prefix = "";
		var name   = gettextCatalog.getString( 'Unnamed object' );

		if (type) {

			prefix = (this.objectTypeI18nLabels[ type ] || type) + ": ";

			name = this.getName( object, type ) || this.getIdentification( object, type );
		}

		return prefix + name;
	}
}

ObjectNamingService.$inject = [ "$rootScope", "gettextCatalog", "objectSolverService" ];
